import { RegionInfoDto, CreateRegionDto } from '@sr/dto';
import { REGIONS_BASE_URL } from 'shared/api/api';
import { CollectionParams } from 'shared/api/rtk-query';
import { regionApi } from './regionApiSlice';

const injectedApi = regionApi.injectEndpoints({
  endpoints: (builder) => ({
    getRegionsList: builder.query<RegionInfoDto[], CollectionParams>({
      query: ({ filter }: CollectionParams) => ({
        url: `${REGIONS_BASE_URL}?${filter}`,
        method: 'GET'
      }),
      providesTags: ['Regions']
    }),

    deleteRegion: builder.mutation<void, number>({
      query: (regionId: number) => ({
        url: `${REGIONS_BASE_URL}/${regionId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Regions']
    }),

    addRegion: builder.mutation<RegionInfoDto, CreateRegionDto>({
      query: (dto) => ({
        url: `${REGIONS_BASE_URL}`,
        body: dto,
        method: 'POST'
      }),
      invalidatesTags: ['Regions']
    }),
  }),
  overrideExisting: true
});

export const regionListApi = injectedApi;